






























import Vue from 'vue';
import GlowingBulbVariant from '@/enums/GlowingBulbVariant';

export default Vue.extend({
  name: 'GlowingBulb',
  props: {
    variant: {
      type: Number as () => GlowingBulbVariant,
      required: true,
    },
  },
  computed: {
    imageClass(): string {
      switch (this.variant) {
        case GlowingBulbVariant.OnOff:
          return 'bulb-blinking';
        case GlowingBulbVariant.Pairing:
          return 'bulb-pulsing';
        case GlowingBulbVariant.APPairing:
          return 'bulb-double-pulsing';
      }
      return '';
    },
        сontainerClass(): string {
      switch (this.variant) {
        case GlowingBulbVariant.OnOff:
          return 'container-blinking';
        case GlowingBulbVariant.Pairing:
          return 'container-pulsing';
        case GlowingBulbVariant.APPairing:
          return 'container-double-pulsing';
      }
      return '';
    },

  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shortcutInstructions/subcomponents/GlowingBulb.vue